module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAABEElEQVRIie3XMWoCURSF4X90SGUVUHCKRAhxA1Ma0MoVCELShmQFtrFxA2JjLViKXTZgIyRi4QbERjdgEzQTzuBA3MC9hZ5quu8N771zeUEcx01gAFSxyQGYAy/5KIpmQMUIVnLAHXCrj7Ih/D8POSc4jTv+42TvhY+c8HEIvAOfQNEITYCVrpvwX2BqBJ8lSJLEw03jetpVr2649rwEdIB7I1Nn7BvoC58AT0ZwljZQ0J7XjOEsdeGBEx5e7GA5Cv9ywtN6bQEfhlftCCyAnvAN8GoEn+Xa7S4JTyXTAB6NFnA43bCV8CHwZvznGi7PejRosOSN8SAbLDfGcJbCZT8atk72WriqdWeIqlKXQPcPJNItN7en1tAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon-nav.png
// module id = 2NoZ
// module chunks = 0